import { render, staticRenderFns } from "./NoveltyListComponent.vue?vue&type=template&id=c71e1346"
import script from "./NoveltyListComponent.vue?vue&type=script&lang=js"
export * from "./NoveltyListComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports